import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import { nearByPlaces } from "../../api/categories";
import { createVibe } from "../../api/categories";
import { getGeoCode } from "../../api/categories";
// import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
// import { useLocation } from "react-router-dom";
import Loader from "../../components/Loader";
import secureStorage from "../../utils/secureStorage";

const Step4SelectPlace = ({ formData, setFormData, goNext, goBack }) => {
  const { t } = useTranslation();
  // const location = useLocation();
  // 
  // In Step4Venues.jsx

  const [searchTerm, setSearchTerm] = useState("");
  const [places, setPlaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [coords, setCoords] = useState(null); // { latitude, longitude }
  // Only venue selection logic here

  const storedUser = secureStorage.getJSON("user");
  const user = storedUser || null;

  // Acquire browser geolocation once on mount (fallback to stored user address)
  useEffect(() => {
    let cancelled = false;
    const tryGeolocate = () => {
      if (!("geolocation" in navigator)) {
        // fallback to stored user address
        const latitude = user?.addresses?.latitude;
        const longitude = user?.addresses?.longitude;
        if (latitude && longitude) setCoords({ latitude, longitude });
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          if (cancelled) return;
          const { latitude, longitude } = pos.coords || {};
          if (typeof latitude === "number" && typeof longitude === "number") {
            setCoords({ latitude, longitude });
          } else {
            // fallback to stored
            const lat = user?.addresses?.latitude;
            const lng = user?.addresses?.longitude;
            if (lat && lng) setCoords({ latitude: lat, longitude: lng });
          }
        },
        (err) => {
          // permission denied or error -> fallback to stored
          const lat = user?.addresses?.latitude;
          const lng = user?.addresses?.longitude;
          if (lat && lng) setCoords({ latitude: lat, longitude: lng });
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 60000,
        }
      );
    };
    tryGeolocate();
    return () => {
      cancelled = true;
    };
  }, [user?.addresses?.latitude, user?.addresses?.longitude]);

  // Fetch real nearby places from API
  useEffect(() => {
    const fetchPlaces = async () => {
      setLoading(true);
      try {
        // Determine coordinates: prefer browser coords, then stored user address
        const latitude = coords?.latitude ?? user?.addresses?.latitude;
        const longitude = coords?.longitude ?? user?.addresses?.longitude;
        if (!latitude || !longitude) {
          setPlaces([]);
          setLoading(false);
          return;
        }
        // Prepare API body from formData
        const radius = formData.radius || "50000";
        const type = formData.type || "shopping_mall";
        const language = formData.language || "en";
        const params = { latitude, longitude, radius, type, language };
        const data = await nearByPlaces(params);
        setPlaces(Array.isArray(data?.data?.results) ? data.data.results : []);
      } catch (error) {
        setPlaces([]);
      }
      setLoading(false);
    };
    fetchPlaces();
  }, [
    formData.type,
    formData.radius,
    coords?.latitude,
    coords?.longitude,
    user?.addresses?.latitude,
    user?.addresses?.longitude,
    formData.language,
  ]);

  const handleSelectPlace = (place) => {
    setFormData({ ...formData, selectedPlace: place, venue: place?.name });
  };

  return (
    <>
      {/* DEBUG: Show step and places count */}
      {/* <div className="mb-2 p-2 bg-yellow-100 text-yellow-800 rounded">Step 4 Rendered. Places fetched: {places.length}</div> */}
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <button
          onClick={() => {
            goBack();
          }}
          className="px-4 py-2  rounded-lg font-semibold text-gray-700"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        <h1
          className="text-md sm:text-md md:text-lg font-bold "
          style={{ color: "#6d2af6" }}
        >
          {t("vibe", "Vibe")}
        </h1>

        <button
          className={`text-sm px-4 py-2 rounded-lg font-semibold bg-[#6d29f6] text-white flex justify-center items-center whitespace-nowrap min-w-[120px] ${formData.selectedPlace ? "" : "cursor-not-allowed"
            }`}
          style={
            formData.selectedPlace ? { color: "#ffffff" } : { color: "#ffffff" }
          }
          // disabled={!formData.selectedPlace}
          onClick={async () => {
            if (!formData.selectedPlace) {
              toast.error(
                t("please_select_a_category", { category: formData.category })
              );
              return;
            }
            setSaving(true);
            let geoCode = null;
            if (formData.selectedPlace?.geometry?.location) {
              const lat = formData.selectedPlace.geometry.location.lat;
              const lng = formData.selectedPlace.geometry.location.lng;
              try {
                geoCode = await getGeoCode({ latitude: lat, longitude: lng });
              } catch (err) {
              }
            }
            setFormData((prev) => ({
              ...prev,
              venue: formData.selectedPlace?.name,
              geoCode,
            }));
            if (!geoCode.data?.formatted_address) {
              toast.error("Error: formatted address is required.");
              setSaving(false);
              return;
            }

            const payload = {
              id: formData.id,
              vibe_category_id: formData.vibe_category_id,
              category_id: formData.category_id,
              venue: formData.selectedPlace?.name || formData.addresses,
              addressLine1: geoCode?.addressLine1 || "",
              addressLine2: geoCode?.addressLine2 || "",
              address_with_city_state: geoCode?.address_with_city_state || "",
              business_name: geoCode?.business_name || "",
              city: geoCode.data?.city || "",
              country: geoCode.data?.country || "",
              formatted_address: geoCode.data?.formatted_address || "",
              formatted_address_without_country:
                geoCode.data?.formatted_address_without_country || "",
              latitude: geoCode.data?.latitude || "",
              longitude: geoCode.data?.longitude || "",
              place_id: geoCode.data?.place_id || "",
              state: geoCode.data?.state || "",
              zip: geoCode.data?.zip || "",
              steps: 4,
            };
            try {
              const res = await createVibe(payload);
              setFormData((prev) => ({ ...prev, date: "", time: "" }));
            } catch (err) {
            }
            setSaving(false);
            goNext();
          }}
        >
          {saving ? <Loader loaderColor="white" size={20} /> : t("save_next", "Save & Next")}
        </button>
      </div>

      <h1 className="flex w-full justify-center py-3 text-black text-md sm:text-md md:text-lg font-bold ">
        {formData.category}
      </h1>

      {/* Loading */}
      {loading && (
        <p className="text-gray-500">
          {t("loading_places", "Loading places...")}
        </p>
      )}

      <div className="mb-4">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={t("search_places")}
          className="
      w-full px-3 py-2 border rounded-lg
      bg-white text-black
      dark:bg-[#1a1a1a] dark:text-white
      dark:border-[#333]
      placeholder-gray-500 dark:placeholder-gray-400
      focus:outline-none focus:ring-2 focus:ring-[#6d29f6]
    "
        />
      </div>


      {/* List of Places */}
      {!loading && places.length > 0 && (
        <div className="space-y-3 flex flex-col justify-center items-center">
          {places
            .filter((place) =>
              place.name.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .map((place, idx) => (
              <div
                key={place.place_id || idx}
                onClick={() => handleSelectPlace(place)}
                className="p-4 border-2 rounded-xl cursor-pointer transition text-center border-[#6d29f6] text-gray-700 w-full max-w-xs sm:max-w-sm md:max-w-md mx-auto"
              >
                <div
                  className={`font-bold inline-block px-2 py-1 rounded ${formData.selectedPlace?.place_id === place.place_id
                      ? "bg-[#6d2af6] text-white"
                      : ""
                    }`}
                >
                  {place.name}
                </div>
                <div className="my-2 flex items-center justify-center gap-2">
                  <span className="flex-1 h-px bg-gray-300" />
                  <span className="px-2 text-lg font-bold text-[#6d29f6] dark:text-white">
                    @
                  </span>
                  <span className="flex-1 h-px bg-gray-300" />
                </div>
                <div className="text-sm text-gray-500 dark:bg-[#252739] px-2 py-1 rounded-md">
                  {t("vicinity")}: {place.vicinity}
                </div>
                {/* {place.rating && (
                  <div className="text-xs text-yellow-600">Rating: {place.rating} ⭐</div>
                )} */}
              </div>
            ))}
        </div>
      )}

      {/* No results */}
      {!loading && places.length === 0 && (
        <p className="text-gray-500">{t("no_places_found_for_category")}</p>
      )}
    </>
  );
};

export default Step4SelectPlace;
